window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 0,
        },
        animResult: function (listPrize) {
    
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
   

            
        },
    })

});
